import React from "react";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Container } from "../../components/Container";
import { Box, Flex, Spacer, Center, HStack, Spinner } from "@chakra-ui/react";
import { VimeoVideoCategoriesForm } from "./VimeoVideoCategoriesForm";
import { CalendlySettingsForm } from "./CalendlySettingsForm";
import { SupervisionedWorkoutsForm } from "./SupervisionedWorkoutsForm";

export const AdminSettings: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();

  return (
    <Box p={30} w={"100%"}>
      <Flex mb={"20px"}>
        <Center p="4">{t("screens.adminSettings.title")}</Center>
        <Spacer />
        <HStack p="4">
          {(session.isLoadingVideoCategories ||
            session.isLoadingVimeoVideoCategories) && <Spinner />}
        </HStack>
      </Flex>

      <Container>
        <Box flex={1}>
          <VimeoVideoCategoriesForm />
          <CalendlySettingsForm />
          <SupervisionedWorkoutsForm />
        </Box>
      </Container>
    </Box>
  );
});
